import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classes from './SideBarLink.module.css'


function SideBarLink(props) {
  const [active, setActive] = useState(false);

  useEffect(() => {
        if(props.selected === props.id) {setActive(true); }
        else { setActive(false) }
  }, [props.selected, props.id]);

  let link_style = classes.sidebar_link
  if (active === true) {link_style = classes.sidebar_link_selected}

  return (
    <div className={classes.sidebar_container}>
      <Link className={link_style} id={props.id} to={props.href} onClick={props.onUpdateSelection}>
         {props.children}
      </Link>
    </div>);

  }

export default SideBarLink

